import { useTranslation } from 'react-i18next';
import { Typography } from '@dagensmat/carrot/Components';
import { Container } from '@dagensmat/carrot/Layout';
import { useAppSelector } from '_common/hooks/reduxHooks';
import { InviteUser } from './invite-user';
import { Email } from './email';
import { useUsers } from './use-users';
import { Feedback } from './feedback';

export const EditUsers = () => {
  const { t } = useTranslation();
  const { accountName } = useAppSelector(({ auth }) => {
    return {
      accountName: auth.name
    };
  });

  const {
    loginEmails,
    hideRemoveButton,
    feedback,
    onInvite,
    onInviteInputChange,
    onRemove,
    onRemoveSuccess,
    onRemoveError
  } = useUsers();

  return (
    <Container mb="xl">
      <Typography variant="paragraphBold" as="p" mb="xs">
        {t('consumer:UsersWithAccess', { accountName })}
      </Typography>
      <ul>
        {loginEmails.map(email => {
          return (
            <Email
              key={email}
              email={email}
              hideRemoveButton={hideRemoveButton}
              onRemove={onRemove}
              onRemoveSuccess={onRemoveSuccess}
              onRemoveError={onRemoveError}
            />
          );
        })}
      </ul>
      <InviteUser
        onInvite={onInvite}
        onInviteInputChange={onInviteInputChange}
      />
      <Feedback value={feedback} />
    </Container>
  );
};
